import { render, staticRenderFns } from "./SwitchTheme.vue?vue&type=template&id=27953a87&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SwitchTheme.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/SwitchTheme.vue
// module id = 2439
// module chunks = 1